import { createFileRoute } from '@tanstack/react-router'
import { AdminWebsite, type WebsiteTab } from '@/components/admin/AdminWebsite'
import {
  OnlineOrderingGateSkeleton,
  OnlineOrderingPaywall,
} from '@/components/admin/OnlineOrderingPaywall'
import { useOnlineOrderingEnabled } from '@/hooks/useOnlineOrderingEnabled'

const TABS: WebsiteTab[] = ['design', 'features', 'hours', 'featured', 'contact', 'app']

// The ordering website rides the same premium gate as the Online Orders inbox
// and Delivery Zones (route-level: the editor never loads on locked tenants,
// who see the paywall instead). The tab lives in the URL so a link can open
// straight to Opening hours.
function WebsiteRoute() {
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { enabled, isLoading, isError } = useOnlineOrderingEnabled()
  if (isError)
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 p-8 text-center">
        <p className="text-sm text-muted-foreground">
          Couldn’t load settings. Check your connection and try again.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-md border px-4 py-2 text-sm font-medium hover:bg-muted"
        >
          Retry
        </button>
      </div>
    )
  if (isLoading) return <OnlineOrderingGateSkeleton />
  if (!enabled) return <OnlineOrderingPaywall />
  return <AdminWebsite tab={tab} onTab={(t) => navigate({ search: { tab: t }, replace: true })} />
}

export const Route = createFileRoute('/admin/website')({
  validateSearch: (raw: Record<string, unknown>): { tab: WebsiteTab } => ({
    tab: TABS.includes(raw.tab as WebsiteTab) ? (raw.tab as WebsiteTab) : 'design',
  }),
  component: WebsiteRoute,
})
